import { render, staticRenderFns } from "./edit-select-vcard.vue?vue&type=template&id=27d99eb4&scoped=true&"
import script from "./edit-select-vcard.vue?vue&type=script&lang=js&"
export * from "./edit-select-vcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d99eb4",
  null
  
)

export default component.exports